// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_home__CMw1J {
  width: 100%;
  margin: 1.25rem 0 2rem;
}

.Home_hero__tSEiQ {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(18rem, 0.75fr);
  align-items: center;
  height: clamp(25rem, 42svh, 24rem);
  overflow: hidden;
  background:
    radial-gradient(circle at 75% 15%, rgba(37, 99, 235, 0.16), transparent 30%),
    linear-gradient(135deg, #ffffff 0%, #f7f9fd 60%, #eef3fb 100%);
  border: 1px solid #dbe2ea;
  border-radius: 1.2rem;
  box-shadow: 0 1rem 3rem rgba(35, 49, 66, 0.09);
}

.Home_heroContent__aJMJQ {
  position: relative;
  z-index: 2;
  padding: clamp(1.6rem, 5vw, 4.2rem);
}

.Home_eyebrow__7XPrp {
  color: #2563eb;
  font-size: 0.74rem;
  font-weight: 900;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.Home_hero__tSEiQ h1 {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  margin: 0.55rem 0 0.9rem;
  color: #243142;
  font-family: var(--title);
  font-size: clamp(2.1rem, 5vw, 4.2rem);
  line-height: 0.98;
}

.Home_hero__tSEiQ h1 span {
  color: #e40032;
  font-size: 0.42em;
  font-weight: 900;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.Home_hero__tSEiQ p {
  max-width: 43rem;
  margin: 0;
  color: #667085;
  font-size: clamp(0.98rem, 1.4vw, 1.15rem);
  line-height: 1.55;
  text-align: left;
}

.Home_homeImageIcon__ovCAq {
  width: 100%;
  height: 100%;
  min-height: 0;
  min-width: 0;
  object-fit: contain;
  opacity: 0.92;
  mask-image: linear-gradient(to right, transparent 0%, black 24%);
}

.Home_actions__CHpS9 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
  margin-top: 0.9rem;
}

.Home_actionCard__U4qlh {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.85rem;
  min-height: 6rem;
  padding: 1rem 1.1rem;
  color: #243142;
  text-decoration: none;
  background: #ffffff;
  border: 1px solid #dbe2ea;
  border-radius: 1rem;
  box-shadow: 0 0.55rem 1.7rem rgba(16, 24, 40, 0.06);
  transition: border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}

.Home_actionCard__U4qlh:hover {
  color: #243142;
  border-color: #b9ccf5;
  box-shadow: 0 0.9rem 2.2rem rgba(16, 24, 40, 0.11);
  transform: translateY(-2px);
}

.Home_actionIcon__yDVvO {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  color: #1d4ed8;
  font-size: 0.95rem;
  font-weight: 900;
  background: #eaf2ff;
  border: 1px solid #c7d8ff;
  border-radius: 0.9rem;
}

.Home_actionCard__U4qlh strong,
.Home_actionCard__U4qlh small {
  display: block;
}

.Home_actionCard__U4qlh strong {
  font-family: var(--title);
  font-size: 1.05rem;
}

.Home_actionCard__U4qlh small {
  margin-top: 0.2rem;
  color: #667085;
  font-size: 0.82rem;
  line-height: 1.35;
}

.Home_actionCard__U4qlh i {
  color: #2563eb;
  font-size: 1.2rem;
  font-style: normal;
}

@media (max-width: 800px) {
  .Home_hero__tSEiQ {
    grid-template-columns: 1fr;
    height: auto;
    min-height: 20rem;
  }

  .Home_homeImageIcon__ovCAq {
    position: absolute;
    inset: 0 0 0 auto;
    width: 55%;
    opacity: 0.25;
  }

  .Home_actions__CHpS9 {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 560px) {
  .Home_hero__tSEiQ {
    border-right: 0;
    border-left: 0;
    border-radius: 0;
  }

  .Home_home__CMw1J {
    margin-top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8DAA8D;EAC9D,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB;EAChB;;kEAEgE;EAChE,yBAAyB;EACzB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,wBAAwB;EACxB,cAAc;EACd,yBAAyB;EACzB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,gEAAgE;AAClE;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mDAAmD;EACnD,gFAAgF;AAClF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kDAAkD;EAClD,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".home {\n  width: 100%;\n  margin: 1.25rem 0 2rem;\n}\n\n.hero {\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(0, 1.25fr) minmax(18rem, 0.75fr);\n  align-items: center;\n  height: clamp(25rem, 42svh, 24rem);\n  overflow: hidden;\n  background:\n    radial-gradient(circle at 75% 15%, rgba(37, 99, 235, 0.16), transparent 30%),\n    linear-gradient(135deg, #ffffff 0%, #f7f9fd 60%, #eef3fb 100%);\n  border: 1px solid #dbe2ea;\n  border-radius: 1.2rem;\n  box-shadow: 0 1rem 3rem rgba(35, 49, 66, 0.09);\n}\n\n.heroContent {\n  position: relative;\n  z-index: 2;\n  padding: clamp(1.6rem, 5vw, 4.2rem);\n}\n\n.eyebrow {\n  color: #2563eb;\n  font-size: 0.74rem;\n  font-weight: 900;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n}\n\n.hero h1 {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  margin: 0.55rem 0 0.9rem;\n  color: #243142;\n  font-family: var(--title);\n  font-size: clamp(2.1rem, 5vw, 4.2rem);\n  line-height: 0.98;\n}\n\n.hero h1 span {\n  color: #e40032;\n  font-size: 0.42em;\n  font-weight: 900;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.hero p {\n  max-width: 43rem;\n  margin: 0;\n  color: #667085;\n  font-size: clamp(0.98rem, 1.4vw, 1.15rem);\n  line-height: 1.55;\n  text-align: left;\n}\n\n.homeImageIcon {\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  min-width: 0;\n  object-fit: contain;\n  opacity: 0.92;\n  mask-image: linear-gradient(to right, transparent 0%, black 24%);\n}\n\n.actions {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.9rem;\n  margin-top: 0.9rem;\n}\n\n.actionCard {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 0.85rem;\n  min-height: 6rem;\n  padding: 1rem 1.1rem;\n  color: #243142;\n  text-decoration: none;\n  background: #ffffff;\n  border: 1px solid #dbe2ea;\n  border-radius: 1rem;\n  box-shadow: 0 0.55rem 1.7rem rgba(16, 24, 40, 0.06);\n  transition: border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;\n}\n\n.actionCard:hover {\n  color: #243142;\n  border-color: #b9ccf5;\n  box-shadow: 0 0.9rem 2.2rem rgba(16, 24, 40, 0.11);\n  transform: translateY(-2px);\n}\n\n.actionIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 3.2rem;\n  height: 3.2rem;\n  color: #1d4ed8;\n  font-size: 0.95rem;\n  font-weight: 900;\n  background: #eaf2ff;\n  border: 1px solid #c7d8ff;\n  border-radius: 0.9rem;\n}\n\n.actionCard strong,\n.actionCard small {\n  display: block;\n}\n\n.actionCard strong {\n  font-family: var(--title);\n  font-size: 1.05rem;\n}\n\n.actionCard small {\n  margin-top: 0.2rem;\n  color: #667085;\n  font-size: 0.82rem;\n  line-height: 1.35;\n}\n\n.actionCard i {\n  color: #2563eb;\n  font-size: 1.2rem;\n  font-style: normal;\n}\n\n@media (max-width: 800px) {\n  .hero {\n    grid-template-columns: 1fr;\n    height: auto;\n    min-height: 20rem;\n  }\n\n  .homeImageIcon {\n    position: absolute;\n    inset: 0 0 0 auto;\n    width: 55%;\n    opacity: 0.25;\n  }\n\n  .actions {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 560px) {\n  .hero {\n    border-right: 0;\n    border-left: 0;\n    border-radius: 0;\n  }\n\n  .home {\n    margin-top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home": `Home_home__CMw1J`,
	"hero": `Home_hero__tSEiQ`,
	"heroContent": `Home_heroContent__aJMJQ`,
	"eyebrow": `Home_eyebrow__7XPrp`,
	"homeImageIcon": `Home_homeImageIcon__ovCAq`,
	"actions": `Home_actions__CHpS9`,
	"actionCard": `Home_actionCard__U4qlh`,
	"actionIcon": `Home_actionIcon__yDVvO`
};
export default ___CSS_LOADER_EXPORT___;
